<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    width="24"
    height="24"
  ><path
    fill="#FFF"
    d="M0 85.337h512v341.326H0z"
  /><path
    fill="#D80027"
    d="M0 85.337h512v113.775H0z"
  /><path
    fill="#338AF3"
    d="M0 312.888h512v113.775H0z"
  /></svg>
</template>
